/** Canonical statuses shared by filtering, property pickers and boards. */
export const ISSUE_STATUSES = ["backlog", "started", "pending", "done", "completed"] as const;
export const TASK_STATUSES = ["backlog", "planned", "started", "pending", "done", "completed"] as const;
// Legacy canceled records remain readable; new work uses the canonical statuses.
export type TaskStatus = (typeof TASK_STATUSES)[number] | "canceled";
export type IssueTab = "all" | "active" | (typeof ISSUE_STATUSES)[number];
export type TaskTab = "all" | (typeof TASK_STATUSES)[number];
export const TASK_STATUS_COLOR: Record<TaskStatus, string> = {
  backlog: "#8b8d91", planned: "#c8c9cc", started: "#f2c94c",
  pending: "#b08a3a", done: "#80bba1", completed: "#4cb782", canceled: "#8b8d91",
};

export function isFinalStatus(status?: string) {
  return status === "completed" || status === "canceled";
}

export function isActiveStatus(status?: string) {
  return status === "unstarted" || status === "started" || status === "pending" || status === "done";
}

export function matchesIssueTab(status: string | undefined, tab: IssueTab) {
  return tab === "all" || (tab === "active" ? isActiveStatus(status) : status === tab);
}

export function matchesTaskTab(status: string, tab: TaskTab) {
  return tab === "all" || status === tab;
}

/** Work awaiting review stays open and cannot complete dependent work. */
export function progressCredit(status?: string) {
  if (status === "completed") return 1;
  if (status === "started" || status === "pending" || status === "done") return 0.25;
  return 0;
}
